var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoutonrond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bouton_rond",
    "data-name": "bouton rond",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#daab3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-arrow-left",
    d: "M6.8,17.2l.793.793a.854.854,0,0,0,1.211,0l6.942-6.939a.854.854,0,0,0,0-1.211L8.8,2.9a.854.854,0,0,0-1.211,0L6.8,3.692a.858.858,0,0,0,.014,1.225l4.3,4.1H.854A.855.855,0,0,0,0,9.873v1.143a.855.855,0,0,0,.857.857H11.117l-4.3,4.1A.852.852,0,0,0,6.8,17.2Z",
    transform: "translate(27.004 24.354)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoutonrond);
export default __webpack_public_path__ + "static/media/bouton rond.9149318167d9dcc6ea16a06fe46db6bc.svg";
export { ForwardRef as ReactComponent };